// Reserved first-label hostnames that always resolve to the central hub
// branding/registration flow rather than a tenant lookup. Matched against
// labels[0] only (not a substring of the whole hostname), so a per-tenant
// staging host like "wessex-water.staging.riverbid.co.uk" still resolves
// "wessex-water" as the tenant slug — only a bare "staging.riverbid.co.uk"
// hits this list.
// 🛡️ Keep in sync with backend/routes/clients.js RESERVED_SUBDOMAINS.
export const RESERVED_SUBDOMAINS = ['app', 'www', 'staging', 'admin', 'api', 'mail', 'demo', 'test'];

// Returns the tenant slug for a hostname, or null for the central hub
// (bare host like "localhost", or a reserved first label).
export const getTenantSlugFromHostname = (hostname = window.location.hostname) => {
  const labels = hostname.split('.');

  if (labels.length === 1 || RESERVED_SUBDOMAINS.includes(labels[0])) {
    return null;
  }

  return labels[0];
};
